import { Box, Flex, Hide, Show } from "@chakra-ui/react"
import { DeliveryInfoListModel } from "../../../../../api-clients/product-api-v1"
import { sectionColumnBreakpoints } from "../../../../../common/constants/pdp-constants"
import { useBrandedTranslation } from "../../../../../common/hooks/useBrandedTranslation"
import { determineNumberOfRows } from "../../../../../common/utils/pdp-utils"
import { SectionTitle } from "../../../../shared/SectionTitle"
import ScopeOfDeliveryColumn from "./ScopeOfDeliveryColumn"

type Props = {
  scopeOfDelivery: DeliveryInfoListModel
  areLinksExternal?: boolean
}

const ScopeOfDelivery = ({ scopeOfDelivery, areLinksExternal = false }: Props) => {
  const { t } = useBrandedTranslation()
  const scopeOfDeliveryIncludedNumberOfRows = determineNumberOfRows(scopeOfDelivery?.included?.length ?? 0)
  const scopeOfDeliveryNotIncludedNumberOfRows = determineNumberOfRows(scopeOfDelivery?.notIncluded?.length ?? 0)

  return (
    <>
      <SectionTitle title={t("pdp-nav-delivery")} mb="6" />

      <Show above="md">
        <Flex gap="6">
          <ScopeOfDeliveryColumn
            scopeOfDelivery={scopeOfDelivery?.included?.slice(0, scopeOfDeliveryIncludedNumberOfRows) ?? []}
          />

          {(scopeOfDelivery?.included?.length ?? 0) > sectionColumnBreakpoints.FIRST_BREAKPOINT && (
            <ScopeOfDeliveryColumn
              scopeOfDelivery={scopeOfDelivery?.included?.slice(scopeOfDeliveryIncludedNumberOfRows) ?? []}
            />
          )}
        </Flex>
      </Show>

      <Hide above="md">
        <ScopeOfDeliveryColumn scopeOfDelivery={scopeOfDelivery?.included ?? []} />
      </Hide>

      {!!scopeOfDelivery?.notIncluded?.length && (
        <Box mt="10">
          <SectionTitle
            as="h3"
            fontSize={{ base: "lg", sm: "xl" }}
            mb={{ base: "4", md: "5" }}
            title={t("pdp-delivery-notIncluded")}
          />

          <Show above="md">
            <Flex gap="6">
              <ScopeOfDeliveryColumn
                areLinksExternal={areLinksExternal}
                scopeOfDelivery={scopeOfDelivery?.notIncluded.slice(0, scopeOfDeliveryNotIncludedNumberOfRows)}
              />

              {scopeOfDelivery?.notIncluded.length > sectionColumnBreakpoints.FIRST_BREAKPOINT && (
                <ScopeOfDeliveryColumn
                  areLinksExternal={areLinksExternal}
                  scopeOfDelivery={scopeOfDelivery?.notIncluded.slice(scopeOfDeliveryNotIncludedNumberOfRows)}
                />
              )}
            </Flex>
          </Show>

          <Hide above="md">
            <ScopeOfDeliveryColumn scopeOfDelivery={scopeOfDelivery?.notIncluded} areLinksExternal={areLinksExternal} />
          </Hide>
        </Box>
      )}
    </>
  )
}

export default ScopeOfDelivery
